// extracted by mini-css-extract-plugin
export default {"users-wrapper":"UsersManagement_users-wrapper__1XoqP","user-card-container":"UsersManagement_user-card-container__MW1VO","user-card-item":"UsersManagement_user-card-item__i4WH6"};